import React, { memo } from 'react'

import logoDark from '@/assets/svg/logo-dark.svg'
import logoLight from '@/assets/svg/logo-light.svg'

export interface BrandLogoProps {
  className?: string
  isDark?: boolean
}

const BrandLogo = memo(({ className, isDark }: BrandLogoProps) => {
  if (isDark)
    return <img src={logoDark} alt="Docsum Logo" className={className} />

  return <img src={logoLight} alt="Docsum Logo" className={className} />
})

BrandLogo.displayName = 'Sidebar.BrandLogo'

export default BrandLogo
